$(document).on('turbolinks:load', () => {
  if ($('.price-timetable-len').length) {
    changeTimeWindowShowable()
  }
})

$(document).on('change', '.price-timetable-len', () => {
  changeTimeWindowShowable()
})

changeTimeWindowShowable = () => {
  max = $('#price-timetable-params').data('max')
  len = $('.price-timetable-len').find('option:selected').val()
  
  for (i = 1; i <= max; i++) {
    if (i <= len) {
      $(`.price-timetable-form-${i-1}`).show()
    } else {
      $(`.price-timetable-form-${i-1}`).hide()
    }
  }
}

$(document).on('change', '[class*=price-timetable-end]', (e) =>{
  changeTimeWindowStart($(e.currentTarget))
})

changeTimeWindowStart = (selector) => {
  end_idx = 0
  $(selector.attr('class').split(' ')).each((idx, class_name) => {
    if (class_name.indexOf('price-timetable-end') > -1) {
      end_idx = parseInt(class_name.replace('price-timetable-end-', ''))
    }
  })

  len = $('.price-timetable-len').find('option:selected').val()
  start_selector = null
  if (end_idx+1 >= len) {
    start_selector = $(".price-timetable-start-0")
  } else {
    start_selector = $(`.price-timetable-start-${end_idx+1}`)
  }

  if (start_selector.val() == "") {
    end_hour = parseInt(selector.find('option:selected').val())
    start_selector.val(end_hour)
  }
}
